import React, { useEffect, useState } from "react";
import OnboardingSteps from "./OnboardingSteps";
import { getCurrentUser } from "../../store/auth";
import { useDispatch, useSelector } from "react-redux";
import { getAppFormLibrary, getAppTasks, getCandidateApps, loadAppFormLibrary, loadAppRuningTasks, loadCandidateApps } from "../../store/candidate";
import { getFieldData, getWfPhasesColor } from "../../../Services/appService";
import Moment from "react-moment";
import { useLocation, useNavigate } from "react-router-dom";
import CandidateInfo from "../CandidateInfo";
import PartnerInfo from "../PartnerInfo";
import EnrollmentSteps from "./EnrollmentSteps";
import { setCurrentPageTitle, setCurrentRoute } from "../../store/layoutUI";
import { getWorkflowTask, loadWorkflowTask, workflowTaskReceived } from "../../store/WorkflowEngine";
import { addFormLibrary, formLibraryAdded, getAppFormLibraryAddedStatus } from "../../store/forms";
import { loadToolsCount } from "../../store/tools";

const ONBOARDING_PAGE_STYLES = {
    shell: {
        marginTop: "10px"
    },
    card: {
        borderRadius: "22px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "linear-gradient(180deg, #ffffff 0%, #fcfdff 100%)",
        boxShadow: "0 14px 30px rgba(15, 23, 42, 0.05)",
        overflow: "hidden"
    },
    cardHeader: {
        padding: "20px 22px 16px 22px",
        borderBottom: "1px solid rgba(226, 232, 240, 1)",
        background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
    },
    headerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap"
    },
    headerCopy: {
        minWidth: "240px",
        flex: "1 1 420px"
    },
    headerActions: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    cardTitle: {
        fontSize: "18px",
        fontWeight: 800,
        color: "#0f172a",
        lineHeight: 1.25,
        margin: 0
    },
    titleRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "12px"
    },
    titleIcon: {
        width: "34px",
        height: "34px",
        borderRadius: "10px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#eef2ff",
        color: "#4f46e5",
        fontSize: "15px",
        border: "1px solid rgba(224, 231, 255, 1)",
        flexShrink: 0
    },
    titleText: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        minWidth: 0
    },
    cardText: {
        fontSize: "13px",
        lineHeight: 1.5,
        color: "#64748b",
        margin: 0
    },
    cardBody: {
        padding: "18px 22px 22px 22px"
    },
    bodyInner: {
        borderRadius: "0 0 22px 22px",
        background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)"
    },
    utilityRow: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "12px",
        flexWrap: "wrap",
        marginBottom: "14px"
    },
    refreshButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#334155",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700,
    },
    tableWrap: {
        border: "1px solid rgba(226, 232, 240, 1)",
        borderRadius: "18px",
        overflow: "auto",
        backgroundColor: "#ffffff",
        boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)"
    },
    table: {
        marginBottom: 0
    },
    tableHeadCell: {
        borderTop: "none",
        fontSize: "12px",
        fontWeight: 800,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        background: "#f8fafc",
        padding: "14px 16px"
    },
    idColumn: {
        width: "14%"
    },
    dateColumn: {
        width: "41%"
    },
    actionColumn: {
        width: "45%"
    },
    startColumn: {
        width: "86%"
    },
    idValue: {
        display: "inline-flex",
        alignItems: "center",
        minHeight: "30px",
        fontSize: "16px",
        fontWeight: 800,
        color: "#0f172a"
    },
    datePrimary: {
        fontSize: "15px",
        fontWeight: 800,
        color: "#0f172a",
        marginBottom: "2px"
    },
    dateSecondary: {
        fontSize: "13px",
        color: "#64748b"
    },
    actionStack: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
        flexWrap: "wrap"
    },
    primaryAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        borderRadius: "999px",
        border: "1px solid rgba(224, 231, 255, 1)",
        background: "#eef2ff",
        color: "#4f46e5",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700
    },
    secondaryAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        borderRadius: "999px",
        border: "1px solid rgba(224, 231, 255, 1)",
        background: "#eef2ff",
        color: "#4f46e5",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700
    },
    startButton: {
        borderRadius: "999px",
        padding: "8px 14px",
        fontWeight: 700
    },
    loadingCell: {
        padding: "20px",
        textAlign: "center"
    }
};

export default function Onboarding() {

    const usrType = localStorage.getItem("userType");

    const route = [
        { name: "Task Management", url: "" },
        { name: "Onboarding Steps", url: "" },
    ];
    const route1 = [
        { name: "Contract Management", url: "" },
        { name: "Enrollment Steps", url: "" },
    ];

    let appType = "Onboarding Form";
    if (usrType === "candidate")
        appType = "Onboarding Form";

    const [appTasklist, setAppTasklist] = useState([]);
    const [entityType, setEntityType] = useState("");
    const [count, setCount] = useState(0);
    const [appSubmitStatus, setAppSubmitStatus] = useState(false);
    const [startBtnProccess, setStartBtnProccess] = useState(false);
    const [loadingStatus, setLoadingStatus] = useState(false);
    const [addFormlibraryStatus, setAddFormlibraryStatus] = useState(false);
    const [wfId, setWfId] = useState(null);
    const [wfTask, setWfTask] = useState(null);

    const candidateAppsSelector = useSelector(getCandidateApps);
    const appTasksSelector = useSelector(getAppTasks);
    const workflowTaskSelector = useSelector(getWorkflowTask);
    const appFormLibrarySelector = useSelector(getAppFormLibrary);
    const appFormLibraryAddedStatusSelector = useSelector(getAppFormLibraryAddedStatus);

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();
    const navigate = useNavigate();

    const location = useLocation();

    useEffect(() => {
        dispatch(setCurrentPageTitle(`STEP-1 : ${appType}`));
        dispatch(setCurrentRoute(usrType === "candidate" ? route : route1))
    }, [])

    useEffect(() => {
        if (currentUser?.id > 0) {
            setLoadingStatus(true);
            if (currentUser.linkUser)
                dispatch(loadCandidateApps(currentUser.linkUser));
            else
                dispatch(loadCandidateApps(currentUser.id));
        }
    }, []);

    useEffect(() => {
        if (candidateAppsSelector.length > 0 && currentUser?.id > 0) {
            const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
            if (mainWorkflow.length > 0) {
                const wf = mainWorkflow[0];
                setWfId(wf.oldWorkflowId);
                if (currentUser?.id > 0) {
                    if (currentUser.linkUser)
                        dispatch(loadAppRuningTasks(wf.oldWorkflowId, currentUser.linkUser));
                    else
                        dispatch(loadAppRuningTasks(wf.oldWorkflowId, currentUser.id));
                }
            }
        }
    }, [candidateAppsSelector]);

    useEffect(() => {
        if (appTasksSelector.length > 0) {
            const filterTasks = appTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0 && x.taskName === "Onboarding/Enrollment");
            let firstAppTasks = [];
            if (filterTasks.length > 0) {
                firstAppTasks = [filterTasks[0]];
                setAppTasklist(firstAppTasks);
                setAppSubmitStatus(firstAppTasks[0].appSubmit);
                const entType = getFieldData(
                    filterTasks[0].stateData,
                    "candidateonboardingform",
                    "CandidateEntity"
                );
                setEntityType(entType);
                const tsk = filterTasks[0];
                setWfTask({
                    ciid: tsk.ciid,
                    wiid: tsk.wiid,
                    iiid: tsk.iiid,
                    applicantId: tsk.performerId,
                    performerId: 1,
                });
                if (wfId && entType !== "C2C Basis" && !addFormlibraryStatus) {
                    setAddFormlibraryStatus(true);
                    if (currentUser.linkUser)
                        dispatch(loadAppFormLibrary(wfId, currentUser.linkUser));
                    else
                        dispatch(loadAppFormLibrary(wfId, currentUser.id));
                }
            }

            setLoadingStatus(false);
        }
    }, [appTasksSelector]);

    const handleCurrentTask = (wiid) => {
        setStartBtnProccess(true);
        dispatch(loadWorkflowTask(wiid));
    }

    useEffect(() => {
        if (workflowTaskSelector && startBtnProccess) {
            setStartBtnProccess(false);
            if (workflowTaskSelector.formType === "CF")
                navigate("/" + workflowTaskSelector.formName, { state: { workflowTask: workflowTaskSelector } });
            else
                navigate("/DynamicForm", { state: { workflowTask: workflowTaskSelector } });

            dispatch(workflowTaskReceived(""));
        }
    }, [workflowTaskSelector]);

    const handleViewAppSummary = (item, type) => {
        navigate("/ApplicationSummary", { state: { task: item, viewType: type } });
    }

    useEffect(() => {
        const achObj = {
            formId: 47,
            formName: "ACH Payment Information",
            remarks:
                "This information is captured for making Payments to your company by ACH",
            formType: "ACH Information",
        };

        const insObj = {
            formId: 22,
            formName: "Insurance Details",
            remarks:
                "Upload your company's insurance certificate(s) as per the contract requirements",
            formType: "Insurance Information",
        };

        if (appFormLibrarySelector.length > 0) {
            const achForm = appFormLibrarySelector.filter(x => x.formType === "ACH Information");
            if (achForm.length === 0) {
                addReqFormLibrary(wfTask, achObj)
            }
            const insForm = appFormLibrarySelector.filter(x => x.formType === "Insurance Information");
            if (insForm.length === 0) {
                addReqFormLibrary(wfTask, insObj)
            }
        } else if (wfTask && entityType !== "C2C Basis" && addFormlibraryStatus) {
            addReqFormLibrary(wfTask, achObj);
            addReqFormLibrary(wfTask, insObj);
        }
    }, [appFormLibrarySelector]);

    const addReqFormLibrary = async (currentTask, frmObj) => {
        const frmData = new FormData();
        frmData.append("workflowTask", JSON.stringify(currentTask));
        frmData.append("formId", frmObj.formId);
        frmData.append("formName", frmObj.formName);
        frmData.append("remarks", frmObj.remarks);
        frmData.append("id", "");
        frmData.append("formType", frmObj.formType);
        frmData.append("status", "1");
        dispatch(addFormLibrary(frmData));
    };

    useEffect(() => {
        if (appFormLibraryAddedStatusSelector) {

            if (currentUser.linkUser)
                dispatch(loadToolsCount(currentUser.linkUser));
            else
                dispatch(loadToolsCount(currentUser.id));

            dispatch(formLibraryAdded(false))
        }
    }, [appFormLibraryAddedStatusSelector])

    const handleRefresh = () => {
        let usrId = currentUser.id;
        if (currentUser.linkUser) usrId = currentUser.linkUser;
        if (usrId > 0) dispatch(loadCandidateApps(usrId));
        if (wfId && usrId > 0) dispatch(loadAppRuningTasks(wfId, usrId));
    };

    return <React.Fragment>

        <div className="mt-2 form-group">
            <style>{`
                .onboarding-form-table thead th {
                    border-top: none;
                    font-size: 12px;
                    font-weight: 800;
                    letter-spacing: 0.08em;
                    text-transform: uppercase;
                    color: #64748b;
                    background: #f8fafc;
                    padding: 14px 16px;
                }

                .onboarding-form-table tbody td {
                    vertical-align: middle;
                    padding: 18px 16px;
                    border-top: 1px solid rgba(241, 245, 249, 1);
                    background: #ffffff;
                }

                .onboarding-form-table tbody tr:hover td {
                    background-color: #f8fbff;
                }

                @media (max-width: 767.98px) {
                    .onboarding-form-table {
                        min-width: 720px;
                    }
                }
            `}</style>

            <div className="card shadow-none border-1" style={{ ...ONBOARDING_PAGE_STYLES.card }}>
                <div className="card-header border-1" style={ONBOARDING_PAGE_STYLES.cardHeader}>
                    <div style={ONBOARDING_PAGE_STYLES.headerRow}>
                        <div style={ONBOARDING_PAGE_STYLES.headerCopy} title="Onboarding Form is completed">
                            <div style={ONBOARDING_PAGE_STYLES.titleRow}>
                                <span style={ONBOARDING_PAGE_STYLES.titleIcon}>
                                    <i className="fa fa-file-text-o" aria-hidden="true"></i>
                                </span>
                                <div style={ONBOARDING_PAGE_STYLES.titleText}>
                                    <div style={ONBOARDING_PAGE_STYLES.cardTitle}>Onboarding Form</div>
                                    {!appSubmitStatus && (
                                        <p style={ONBOARDING_PAGE_STYLES.cardText}>
                                            Click on START button below to complete your {appType}
                                        </p>
                                    )}
                                    {appSubmitStatus && (
                                        <p style={ONBOARDING_PAGE_STYLES.cardText}>
                                            Review the submitted onboarding record and open it for viewing or updates.
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div style={ONBOARDING_PAGE_STYLES.headerActions}>
                            <button
                                className="btn btn-sm"
                                style={ONBOARDING_PAGE_STYLES.refreshButton}
                                onClick={handleRefresh}
                            >
                                <i className="fa fa-refresh" aria-hidden="true"></i>
                                Refresh
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card-body border-1" style={ONBOARDING_PAGE_STYLES.cardBody}>
                    <div style={ONBOARDING_PAGE_STYLES.bodyInner}>
                        <div className="table-responsive" style={ONBOARDING_PAGE_STYLES.tableWrap}>
                            <table className="table onboarding-form-table" style={ONBOARDING_PAGE_STYLES.table}>
                                <colgroup>
                                    <col style={ONBOARDING_PAGE_STYLES.idColumn} />
                                    {appSubmitStatus && <>
                                        <col style={ONBOARDING_PAGE_STYLES.dateColumn} />
                                        <col style={ONBOARDING_PAGE_STYLES.actionColumn} />
                                    </>}
                                    {!appSubmitStatus && <col style={ONBOARDING_PAGE_STYLES.startColumn} />}
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th style={ONBOARDING_PAGE_STYLES.tableHeadCell}>ID</th>
                                        {appSubmitStatus && <>
                                            <th style={ONBOARDING_PAGE_STYLES.tableHeadCell}>Date & Time Submitted</th>
                                            <th style={ONBOARDING_PAGE_STYLES.tableHeadCell}>{appType}</th>
                                        </>}
                                        {!appSubmitStatus &&
                                            <th style={ONBOARDING_PAGE_STYLES.tableHeadCell}>Click on below button</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {!loadingStatus ? appTasklist.map(item =>
                                        <tr key={item.wiid}>
                                            <td>
                                                <div style={ONBOARDING_PAGE_STYLES.idValue}>{item.ciid}</div>
                                            </td>

                                            {appSubmitStatus &&
                                                <>
                                                    <td>
                                                        <div style={ONBOARDING_PAGE_STYLES.datePrimary}>
                                                            <Moment format="MMM Do YYYY, h:mm a">
                                                                {item.startDateTime}
                                                            </Moment>
                                                        </div>

                                                    </td>
                                                    <td>
                                                        <div style={ONBOARDING_PAGE_STYLES.actionStack}>
                                                            <button
                                                                onClick={() => handleViewAppSummary(item, "view")}
                                                                className="btn btn-sm border-0"
                                                                style={ONBOARDING_PAGE_STYLES.primaryAction}
                                                            >
                                                                <i className="fa fa-eye" aria-hidden="true"></i>
                                                                View
                                                            </button>
                                                            <button
                                                                onClick={() => handleViewAppSummary(item, "editnId")}
                                                                className="btn btn-sm border-0"
                                                                style={ONBOARDING_PAGE_STYLES.secondaryAction}
                                                            >
                                                                <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                                                Edit/Update
                                                            </button>
                                                        </div>
                                                    </td>
                                                </>
                                            }

                                            {!appSubmitStatus &&
                                                <>
                                                    <td>
                                                        <button
                                                            onClick={() => handleCurrentTask(item.wiid)}
                                                            disabled={item.performerId !== parseInt(currentUser.id) || startBtnProccess}
                                                            className={`btn btn-sm btn-primary border-0`}
                                                            style={ONBOARDING_PAGE_STYLES.startButton}
                                                        >
                                                            {startBtnProccess && <i className="fa fa-spinner fa-spin mr-2"></i>}
                                                            Start {item.taskName}
                                                        </button>
                                                    </td>
                                                </>
                                            }
                                        </tr>
                                    ) : <>
                                        <tr>
                                            <td colSpan={appSubmitStatus ? 3 : 2} style={ONBOARDING_PAGE_STYLES.loadingCell}>
                                                <button className={`btn btn-sm btn-outline-default`}>
                                                    <i className="fa fa-spinner fa-spin mr-2"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </>}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </React.Fragment>
}
